export default __webpack_public_path__ + "static/media/computer.2a4f016d.PNG";